import connectMenu from "../../helpers/connectMenu";
import FolderContextMenu from "../tree-general/FolderContextMenu";

const FlowFolderContextMenu = connectMenu("flow-tree-folder")(FolderContextMenu);
export default FlowFolderContextMenu;
